import { render } from "./FbLoginBtn.vue?vue&type=template&id=4eb3822f&scoped=true"
import script from "./FbLoginBtn.vue?vue&type=script&lang=js"
export * from "./FbLoginBtn.vue?vue&type=script&lang=js"

import "./FbLoginBtn.vue?vue&type=style&index=0&id=4eb3822f&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb3822f"]])

export default __exports__